module.exports = __webpack_public_path__ + "img/ufo_768.fafb6ae8.svg";